export default "__VITE_ASSET__$a3LrK6H__"